import fetch from "../utils/fetch";

/**
 * apphi登录
 * @param basic 用户名密码加密后字符串
 * @param ignoreToken 是否采用新basic替换原有token
 * @returns {*}
 */
export function login({ basic, ignoreToken, with_stripe }) {
  return fetch.get("users/self", {
    ignoreToken,
    headers: {
      Authorization: `Basic ${basic}`,
    },
    params: {
      with_stripe,
    },
  });
}

/**
 * 注册账号
 * @param email 邮箱
 * @param password 密码
 * @returns {*|void|AxiosPromise<any>}
 */
export function register({ email, password }) {
  return fetch.post("users", {
    email,
    password,
  });
}

/**
 * 与指定 publisher 建立绑定关系。
 * http://schedulepost.dev.apphi.com/api/docs/#!/users/Publiship_Model_create
 * @param publisher_username Instagram username
 * @param publisher_password Instagram password
 * @param validation_api_path
 * @param validation_code
 */
export function createPubliships({
  publisher_username,
  publisher_password,
  validation_api_path,
  validation_code,
}) {
  return fetch.post(
    "users/self/publiships",
    {
      publisher_username,
      publisher_password,
      validation_api_path,
      validation_code,
    },
    { ignore401: true, timeout: 90000 }
  );
}

/**
 * 更新信用卡信息
 */
export function updateCard({ credit_card }) {
  return fetch.patch(`users/self`, { credit_card });
}
/**
 * 验证邮箱是否存在
 */
export function validateEmail({ email }) {
  return fetch.get(`users`, { params: { email } });
}
